import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-406d3fbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "custom_progress"
}
const _hoisted_2 = {
  key: 1,
  class: "custom_progress"
}
const _hoisted_3 = {
  key: 2,
  class: "custom_progress"
}

import { withDefaults } from 'vue';

interface IProps {
    value?: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomProgressBar',
  props: {
    value: { default: 0 }
  },
  setup(__props: any) {


const props = __props;


return (_ctx: any,_cache: any) => {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.value < 34)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_progress_linear, {
            color: "#F43841",
            "model-value": _ctx.value,
            "bg-opacity": "1",
            "bg-color": "#D6DBE166",
            rounded: "",
            "rounded-bar": "",
            class: "progress",
            height: "10"
          }, null, 8, ["model-value"]),
          _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.value)) + "%", 1)
        ]))
      : (_ctx.value >= 34 && _ctx.value < 67)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_v_progress_linear, {
              color: "#FFAA00",
              "model-value": _ctx.value,
              "bg-opacity": "1",
              "bg-color": "#D6DBE166",
              rounded: "",
              "rounded-bar": "",
              class: "progress",
              height: "10"
            }, null, 8, ["model-value"]),
            _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.value)) + "%", 1)
          ]))
        : (_ctx.value >= 67)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_v_progress_linear, {
                color: "#00B88D",
                "model-value": _ctx.value,
                "bg-opacity": "1",
                "bg-color": "#D6DBE166",
                rounded: "",
                "rounded-bar": "",
                class: "progress",
                height: "10"
              }, null, 8, ["model-value"]),
              _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.value)) + "%", 1)
            ]))
          : _createCommentVNode("", true)
  ]))
}
}

})